// Action constants
export var PlaywrightAction;
(function (PlaywrightAction) {
    PlaywrightAction["VISIT_BASE_URL"] = "VISIT_BASE_URL";
    PlaywrightAction["VISIT_URL"] = "VISIT_URL";
    PlaywrightAction["CLICK"] = "CLICK";
    PlaywrightAction["FILL_IN"] = "FILL_IN";
    PlaywrightAction["SELECT_DROPDOWN"] = "SELECT_DROPDOWN";
    PlaywrightAction["SELECT_MULTIPLE_DROPDOWN"] = "SELECT_MULTIPLE_DROPDOWN";
    PlaywrightAction["CHECK_CHECKBOX"] = "CHECK_CHECKBOX";
    PlaywrightAction["SELECT_RADIO"] = "SELECT_RADIO";
    PlaywrightAction["TOGGLE_SWITCH"] = "TOGGLE_SWITCH";
    PlaywrightAction["SET_SLIDER"] = "SET_SLIDER";
    PlaywrightAction["TYPE_KEYS"] = "TYPE_KEYS";
    PlaywrightAction["HOVER"] = "HOVER";
    PlaywrightAction["ASSERT_EXACT_VALUE"] = "ASSERT_EXACT_VALUE";
    PlaywrightAction["ASSERT_CONTAINS_VALUE"] = "ASSERT_CONTAINS_VALUE";
    PlaywrightAction["ASSERT_URL"] = "ASSERT_URL";
    PlaywrightAction["SCROLL_TO_ELEMENT"] = "SCROLL_TO_ELEMENT";
    PlaywrightAction["EXTRACT_VALUE"] = "EXTRACT_VALUE";
    PlaywrightAction["ASK_AI"] = "ASK_AI";
    PlaywrightAction["EXECUTE_SCRIPT"] = "EXECUTE_SCRIPT";
    PlaywrightAction["UPLOAD_FILES"] = "UPLOAD_FILES";
    PlaywrightAction["WAIT_FOR"] = "WAIT_FOR";
    PlaywrightAction["WAIT_FOR_OTP"] = "WAIT_FOR_OTP";
    PlaywrightAction["GEN_TOTP"] = "GEN_TOTP";
    // Sequence marker actions (not real interactions, used only for grouping)
    PlaywrightAction["SEQUENCE_START"] = "SEQUENCE_START";
    PlaywrightAction["SEQUENCE_END"] = "SEQUENCE_END";
})(PlaywrightAction || (PlaywrightAction = {}));
//# sourceMappingURL=PlaywrightAction.js.map